import { AfterContentInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/base/base.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends BaseComponent implements AfterContentInit {

  constructor(public router: Router,
    public translate: TranslateService) {
    super(router, translate)
  }

  onLoginWithRE() {
    this.showModal('modalLoginRE')
  }

  ngAfterContentInit(): void {
    super.toggleLoader(false);
  }
}
